import type { CMSFreeFormPageSiteReference, PageContext } from "@types";
import { useCallback } from "react";

const useSiteReference = (pageContext: PageContext): (() => CMSFreeFormPageSiteReference) => {
    const siteReference = useCallback((): CMSFreeFormPageSiteReference => {
        const { site_reference } = pageContext?.page || {};
        return site_reference?.[0];
    }, [pageContext?.page]);

    return siteReference;
};

export default useSiteReference;
